import { QueuedItemStatus } from './QueuedItemStatus';

export interface TagGenerationRequestGq {
  id: number;
  status: QueuedItemStatus;
}

export const TagGenerationRequestGqProps = `
  id
  status
`;
